import {CLEAR_PRICE, SET_PRICE} from "../actions/price";

const initialState = [
    {
        "id": 1,
        "type": "airplane",
        "increase_amount": 0,
        "increase_percent": 20,
        "is_active": 1,
        "item_id": null,
        "start_date": "2018-08-01",
        "end_date": "2020-12-01",
    },
];

export default function price(state = initialState , action = {}){
    switch (action.type) {
        case SET_PRICE :
            const { price } = action;

            return price;
        case CLEAR_PRICE :
            return initialState;
        // break;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/priceReducer.js